import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import EmptyLine from "../EmptyLine";
import {useUser} from "../../../context/UserContext";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultView from "../../../components/ResultView";

export function B27({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.OP03.error_id: {
            return (
                <>
                    <ResultText>
                        There are crossing WSEL profiles at the following {row?.length} cross sections listed below. Profiles crossing more than {settings?.thresholds?.crossing_default} ft are highlighted in red text.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start', verticalAlign: 'top'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(35), textAlign: 'start', verticalAlign: 'top'}}>Crossing Profile</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start', verticalAlign: 'top'}}>
                                            <CheckCSName csName={r.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{
                                            width: HecRasHelper.getWidth(35),
                                            textAlign: 'end',
                                            verticalAlign: 'top'
                                        }}>
                                            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                                                {
                                                    r.profiles?.map((p, idx) => (
                                                        <span>
                                                            <span style={{color: p.crossing < -1 * (settings?.thresholds?.crossing_default) ? 'red' : ''}}>{p.profile}</span>
                                                            {idx < r.profiles.length-1 && <>,&nbsp;</>}
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}